/**
 * Mandatory Terms of Service + Refund Policy checkbox.
 *
 * - Disables the standard "Checkout" button until checked.
 * - Best-effort disables the dynamic checkout buttons (Shop Pay, PayPal,
 *   Apple Pay, Google Pay) too — see README "Limitations".
 * - Once checked, saves the agreement + a UTC timestamp as cart attributes,
 *   which carry over to the order's "Additional details" — usable as
 *   evidence for chargeback / PayPal / Klarna dispute responses.
 *
 * Uses event delegation throughout, so it keeps working even after Dawn
 * re-renders the cart page or drawer — no stale element references to fix.
 */
(function () {
  var CHECKOUT_SELECTOR = 'button[name="checkout"], input[name="checkout"]';
  var DYNAMIC_SELECTOR = '.additional-checkout-buttons, [data-shopify="payment-button"]';
  var CHECKBOX_SELECTOR = '.terms-agreement__checkbox';

  function syncState(agreed) {
    document.body.classList.toggle('terms-not-agreed', !agreed);
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      btn.disabled = !agreed;
    });
    document.querySelectorAll(CHECKBOX_SELECTOR).forEach(function (cb) {
      cb.checked = agreed;
    });
  }

  function showError() {
    document.querySelectorAll('.terms-agreement__error').forEach(function (el) {
      el.hidden = false;
    });
    var box = document.querySelector(CHECKBOX_SELECTOR);
    if (box) {
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
      box.focus();
    }
  }

  function persistAgreement() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Terms & Refund Policy Agreed': 'Yes',
          'Terms Agreed At (UTC)': new Date().toISOString(),
        },
      }),
    }).catch(function (err) {
      console.error('Could not save terms agreement to cart:', err);
    });
  }

  document.addEventListener('change', function (e) {
    if (!e.target.matches(CHECKBOX_SELECTOR)) return;
    syncState(e.target.checked);
    if (e.target.checked) persistAgreement();
  });

  // Capture-phase so this runs before Shopify's own handlers on the
  // dynamic checkout buttons (some render inside iframes / web components).
  document.addEventListener(
    'click',
    function (e) {
      if (!document.body.classList.contains('terms-not-agreed')) return;
      if (e.target.closest(CHECKOUT_SELECTOR) || e.target.closest(DYNAMIC_SELECTOR)) {
        e.preventDefault();
        e.stopPropagation();
        showError();
      }
    },
    true
  );

  syncState(false); // Blocked by default until the box is checked.
})();
